import enumify from './enumify';

const DATASETS = 'datasets';
const PROJECTS = 'projects';
const POLICIES = 'policies';
const USERGROUPS = 'usergroups';
const USERS = 'users';

export default enumify({ DATASETS, PROJECTS, POLICIES, USERGROUPS, USERS });
